import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useEffect } from 'react';

function deleteCognitoCookies() {
  const cookies = document.cookie.split(';');

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cookies.length; i++) {
    const cookieName = cookies[i].split('=')[0].trim();

    if (cookieName.startsWith('CognitoIdentityServiceProvider')) {
      // Establecer una fecha de expiración en el pasado para eliminar la cookie
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
  // remove all cookies
  document.cookie.split(';').forEach(function (c) {
    // if  in cookie delete
    if (c.includes('CognitoIdentityServiceProvider')) {
      const newC = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      document.cookie = newC;
      console.log(`Cookie eliminada: ${c}`, newC);
    }
  });
}

async function guardarTokenEnCookie() {
  try {
    deleteCognitoCookies();
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (!token) {
      console.warn('No token available');
      return;
    }
    // Crear una cookie con duración limitada
    const dias = 1;
    const expira = new Date();
    expira.setTime(expira.getTime() + dias * 24 * 60 * 60 * 1000);
    let domain = window.location.hostname.split('.').slice(-2).join('.');
    if (window.location.hostname === 'localhost') {
      // for all domains
      document.cookie = `authorization=bearer ${token}; path=/; expires=${expira.toUTCString()}; Secure;`;
      console.log('Token guardado en cookie:', token);
    } else {
      document.cookie = `authorization=bearer ${token}; domain=.${domain}; path=/; expires=${expira.toUTCString()}; Secure; SameSite=None`;
      console.log('Token guardado en cookie:', token);
    }
    // Establecer la cookie con el token
  } catch (error) {
    console.error('Error obteniendo el token:', error);
  }
}

export function configureAmplify(config) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    guardarTokenEnCookie();
    return () => {
      deleteCognitoCookies();
    };
  }, []);
  console.log('configureAmplify - original config:', config);
  // Validate required fields
  if (!config.aws_user_pools_id || !config.aws_user_pools_web_client_id) {
    console.error('Missing required Cognito configuration:', {
      userPoolId: config.aws_user_pools_id,
      userPoolClientId: config.aws_user_pools_web_client_id,
    });
    throw new Error('Missing required Cognito User Pool configuration');
  }

  // Convert old Amplify v5 config format to v6 format
  const amplifyV6Config = {
    Auth: {
      Cognito: {
        userPoolId: config.aws_user_pools_id,
        userPoolClientId: config.aws_user_pools_web_client_id,
        ...(config.aws_cognito_identity_pool_id && {
          identityPoolId: config.aws_cognito_identity_pool_id,
        }),
        ...(config.oauth?.domain && {
          loginWith: {
            oauth: {
              domain: config.oauth.domain,
              scopes: config.oauth?.scope || [
                'phone',
                'email',
                'openid',
                'profile',
                'aws.cognito.signin.user.admin'
              ],
              redirectSignIn: [
                `${window.location.protocol}//${window.location.host}/sign-in/verifying`
              ],
              redirectSignOut: [`${window.location.protocol}//${window.location.host}/sign-in`],
              responseType: 'code',
            },
          },
        }),
      },
    },
  };

  console.log('configureAmplify - v6 config:', amplifyV6Config);

  try {
    Amplify.configure(amplifyV6Config);
    console.log('Amplify configured successfully');
  } catch (error) {
    console.error('Error configuring Amplify:', error);
    throw error;
  }

  Hub.listen('auth', ({ payload, }) => {
    const { event, } = payload;
    console.log('[configureAmplify] Hub.listen auth event:', event);
    if (event === 'signIn' || event === 'signedIn' || event === 'signInWithRedirect' || event === 'tokenRefresh') {
      // Obtener el token y guardarlo en una cookie
      guardarTokenEnCookie();
      // Note: This listener does NOT prevent other listeners from receiving the event
      // The SignInVerificationPage listener will still receive the 'signIn' event
    }

    if (event === 'signOut' || event === 'signedOut') {
      // Borrar la cookie si se cierra sesión
      deleteCognitoCookies();
      document.cookie = 'authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  });
}

export default configureAmplify;
